var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustryArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_industries",
    "data-name": "arrow industries",
    transform: "translate(6447 -936) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    transform: "translate(936 6422)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.26345062255859 24 L 7.736549854278564 24 L 1 17.26345062255859 L 1 7.736549854278564 L 7.736549854278564 1 L 17.26345062255859 1 L 24 7.736549854278564 L 24 17.26345062255859 L 17.26345062255859 24 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.150749206542969 2 L 2 8.150749206542969 L 2 16.84925079345703 L 8.150749206542969 23 L 16.84925079345703 23 L 23 16.84925079345703 L 23 8.150749206542969 L 16.84925079345703 2 L 8.150749206542969 2 M 7.322330474853516 0 L 17.67766952514648 0 L 25 7.322330474853516 L 25 17.67766952514648 L 17.67766952514648 25 L 7.322330474853516 25 L 0 17.67766952514648 L 0 7.322330474853516 L 7.322330474853516 0 Z",
    stroke: "none",
    fill: "#f7901f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-arrow-dropright",
    "data-name": "Icon ionic-md-arrow-dropright",
    d: "M13.5,9l7.555,7.555L13.5,24.111l2.18-7.555Z",
    transform: "translate(932.222 6418.444)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryArrow);
export default __webpack_public_path__ + "static/media/industry-arrow.6daef07c3f807b5c70477d08e1219e53.svg";
export { ForwardRef as ReactComponent };